"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProgress = void 0;
var styled_components_1 = require("styled-components");
exports.StyledProgress = styled_components_1.styled.progress(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 30px;\n"], ["\n  width: 100%;\n  height: 30px;\n"])));
var templateObject_1;
